(function($, Drupal) {
  'use strict';

  Drupal.behaviors.anchor_links = {
    attach: function(context, settings) {
      // to top right away
      if (window.location.hash) {
        scroll(0, 0);
      }
      // void some browsers issue
      setTimeout(function() { scroll(0, 0); }, 1);
      $(function() {
        // *only* if we have anchor on the url
        if (window.location.hash) {
          // smooth scroll to the anchor id
          $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 250
          }, 500);
        }
      });

      // Auto scroll to anchor links
      $(document).on('click', 'a[href^="#"]', function(event) {
        event.preventDefault();
        if (!$(this).hasClass('see-footnote')) {
          let target = this.hash;
          let $target = $(target);
          $('html, body').animate({
            scrollTop: $target.offset().top - 250
          }, 500);

          window.location.hash = target;
        }
      });
    }
  };
})(jQuery, Drupal);
